import styled from 'styled-components';
import { rem } from 'polished';

export default styled.div`
  padding-left: ${rem(16)};
  & .cta-button {
    background-color: #fff;
    color: #f4111b;
    font-size: 16px;
    line-height: 26px;
    padding-top: 2px;
  }
`;
